import styled from "styled-components";
import { useEffect, useState } from "react";
import { ASSET_TYPE, DEFAULT_IMAGE_PLACEHOLDER } from "./../../../constants/index";

interface IImageCollection {
  img: any;
  assetType: String;
}

const ImageCollectionItem = (props: IImageCollection) => {
  const [parsedArray, setParsedArray] = useState([]);
  useEffect(() => {
    // setParsedArray(JSON.parse(props?.img));
  }, []);
  return (
    <ImageCollection>
      {props.assetType === ASSET_TYPE.HYBRID ? (
        <div className="wrapper-of-img">
          {/* {JSON.stringify(props.img)} */}
          <div className="green-background"></div>
          <div
            className="left-column-image image-item image-left clickable"
            style={{
              backgroundImage: `url(${props?.img[0] ? props.img[0] : DEFAULT_IMAGE_PLACEHOLDER})`,
            }}
          ></div>
          <div className="d-flex flex-column image-right clickable">
            <div
              className="image-item image-right top-right-border-radius border-bottom-on-image"
              style={{
                backgroundImage: `url(${props?.img[1] ? props.img[1] : DEFAULT_IMAGE_PLACEHOLDER})`,
              }}
            ></div>
            <div
              className="image-item image-right bottom-right-border-radius"
              style={{
                backgroundImage: `url(${props?.img[2] ? props?.img[2] : DEFAULT_IMAGE_PLACEHOLDER})`,
              }}
            ></div>
          </div>
        </div>
      ) : (
        <div className="wrapper-of-img">
          <div className="green-background"></div>
          <div
            className="image-item single-image"
            style={{
              backgroundImage: `url(${props.img[0] || DEFAULT_IMAGE_PLACEHOLDER})`,
            }}
          ></div>
        </div>
      )}
    </ImageCollection>
  );
};

export default ImageCollectionItem;

const ImageCollection = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 26px;
  margin-bottom: 26px;
  border-radius: 16px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 5px;
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .wrapper-of-img {
    width: 205px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 137px;
    }
  }
  .single-image {
    border-radius: 0px 6px 6px 0;
    height: 120px;
    width: 190px;
    margin-left: 1px;
    float: left;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 90px;
      width: 127px;
      border-radius: 0px 4px 4px 0;
    }
  }
  .image-item {
    background-repeat: no-repeat;
    background-size: cover;
  }
  .image-left {
    height: 120px;
    width: 65px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 90px;
      width: 67px;
    }
  }
  .image-right {
    height: 120px;
    width: 95px;
    float: left;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 90px;
      width: 61px;
    }
  }
  .green-background {
    background: #27ce0a;
    width: 11px;
    height: 120px;
    border-radius: 6px 0px 0px 6px;
    float: left;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 90px;
      width: 8px;
      border-radius: 4px 0px 0px 4px;
    }
  }
  .top-right-border-radius {
    border-radius: 0px 6px 0px 0px;
  }
  .bottom-right-border-radius {
    border-radius: 0px 0px 6px 0px;
  }
  .left-column-image {
    border-left: 1px solid white;
    border-right: 1px solid white;
    float: left;
  }
  .border-bottom-on-image {
    border-bottom: 1px solid white;
  }
`;
